import mutations from './stock.mutations'
import actions from './stock.actions'
import getters from './stock.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
